import styled from 'styled-components';

export const StyledImg = styled.img`
  display: inline-block;
`;
